//TODO(yangqing): 和桌面端的弹框整合 DRY
var $ = require('jquery')
  , doc = $(document)
  , docElement = $('html')
  , tmpl = require('./tmpl.handlebars')
  , body = $('body')
  , win = $(window)

function Overlay(opts) {
  this.opts = opts
  this.el = $(tmpl()).appendTo('body')
  this.body = this.el.find('.overlay-in')
  this.closable = opts.closable !== void 0
    ? !!opts.closable : true

  this.setBody()
  this.el.addClass(opts.klass)

  if (!this.closable) { return }

  var overlay = this
  doc.on('click.close', '.overlay-wrap', function(e) {
    if (e.target !== e.currentTarget) { return }
    overlay.close()
  })
  .on('keyup.close', function(e) {
    var tagName = e.target.tagName
      , isEscKey = e.keyCode === 27
      , isInputField = /input|textarea/i.test(tagName)

    if (!isInputField && isEscKey) {
      overlay.close()
    }
  })
}

$.extend(Overlay.prototype, {
  close: function(silent) {
    this.el.remove()
    doc.off('.close')

    return this
  }

, getContentElement: function() {
    return this.el.find('.k-content')
  }

, open: function() {
    this.scrollTop = doc.scrollTop()

    this.el.show()
    return this
  }

, setBody: function(body) {
    body = body || this.opts.body
    this.body.html(body)
    return this
  }
})

module.exports = Overlay;
